
















































































































































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import ReportFileTable from '@/components/ReportFileTable.vue';
import SpeedTable from '@/components/devices/SpeedTable.vue';
import Curvometer from '@/components/devices/Curvometer.vue';
import BreathAnalysis from '@/components/devices/BreathAnalysis.vue';
import DeviceApprovalDetail from '@/views/devices/approvals/Detail.vue';
import { IDRec, DetailLayoutITF, LineValue, Option } from '@/interfaces';
import moment from 'moment';
import { Getter } from 'vuex-class';

@Component({
  components: {
    ReportFileTable,
    SpeedTable,
    Curvometer,
    BreathAnalysis,
    DeviceApprovalDetail
  }
})
export default class DeviceReportDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public statusUpdateDialog = false;
  public version = 1;
  public uploadDialogValue = false;
  public upload = { type: 'report_file_id_nl' };
  public formValid = false;
  public breaths = [
    {
      max_allowed_dev: null,
      standard_l1: null,
      standard_l2: null,
      standard_l3: null,
      temp_l1: null,
      temp_l1b: null,
      temp_l2: null,
      temp_l2b: null,
      temp_l3: null,
      temp_l3b: null,
      measure_l1: null,
      measure_l2: null,
      measure_l3: null,
      uncertain_l1: '0,003',
      uncertain_l2: '0,003',
      uncertain_l3: '0,003'
    },
    {
      max_allowed_dev: null,
      standard_l1: null,
      standard_l2: null,
      standard_l3: null,
      temp_l1: null,
      temp_l1b: null,
      temp_l2: null,
      temp_l2b: null,
      temp_l3: null,
      temp_l3b: null,
      measure_l1: null,
      measure_l2: null,
      measure_l3: null,
      uncertain_l1: '0,003',
      uncertain_l2: '0,003',
      uncertain_l3: '0,003'
    },
    {
      max_allowed_dev: null,
      standard_l1: null,
      standard_l2: null,
      standard_l3: null,
      temp_l1: null,
      temp_l1b: null,
      temp_l2: null,
      temp_l2b: null,
      temp_l3: null,
      temp_l3b: null,
      measure_l1: null,
      measure_l2: null,
      measure_l3: null,
      uncertain_l1: '0,003',
      uncertain_l2: '0,003',
      uncertain_l3: '0,003'
    }
  ];
  public dialog = false;
  public approvalId = '';
  public priv = this.getTableCfg(this.tableCfg, 'priv');

  public get readFilesPrivilege() {
    return this.roleCheck('pr_device_files', 'Read');
  }

  public get writeFilesPrivilege() {
    return this.roleCheck('pr_device_files', 'Write');
  }

  public get isNew() {
    return this.$route.params.id === 'new';
  }

  public consult(id) {
    this.approvalId = String(id);
    this.dialog = true;
  }

  public initDetailView(rec) {
    this.initPrivileges(rec);
    this.initDeviceGroupId(rec);
  }

  public initDeviceGroupId(rec) {
    if (rec.device.devicetype.devicegroup_id) {
      this.setDeviceGroupID(rec.device.devicetype.devicegroup_id);
    }
  }

  public checkSoftware(b) {
    const ref: any = this.$refs.layout;
    ref.rec.check_software = b;
    if (!this.isNew) {
      (ref as DetailLayoutITF).saveRecord();
    }
    this.dialog = false;
  }

  public calculateMaxAllowedDev(rec) {
    // Calculate initial max_allowed_dev
    let defaultMaxAllowedDev = true;
    for (const line of rec.reportlines) {
      if (line.name === 'Test-Herijk' && line.value === '1') {
        defaultMaxAllowedDev = false;
      }
    }
    this.setMaxAllowedDev(rec, defaultMaxAllowedDev);
  }

  public setMaxAllowedDev(rec, defaultMaxAllowedDev) {
    if (rec.device.devicetype.breath_analysis) {
      // Update max_allowed_dev if Test-Herijk changed
      if (!defaultMaxAllowedDev) {
        // Set default max_allowed_dev to 0,03
        rec.breaths[0].max_allowed_dev = '0,03';
        rec.breaths[1].max_allowed_dev = '0,03';
        rec.breaths[2].max_allowed_dev = '0,03';
      } else {
        // Set default max_allowed_dev to 0,02
        rec.breaths[0].max_allowed_dev = '0,02';
        rec.breaths[1].max_allowed_dev = '0,02';
        rec.breaths[2].max_allowed_dev = '0,02';
      }
    }
  }

  public openDevice(id) {
    if (id) {
      const routeData = this.$router.resolve({
        path: '/devices/measuredevices/' + String(id)
      });
      window.open(routeData.href, '_blank');
    }
  }

  public async updateStatus(id) {
    const apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
    if (this.$route.query.mode === 'edit') {
      await this.saveWithFiles(apiUrl);
    }
    const data = {
      description: 'Afgekeurd'
    };
    this.api.postAction(
      this.$store,
      apiUrl + String(id) + '/update_status/',
      data
    );
  }

  public async getDeviceTypeInfo(rec) {
    const deviceID = rec.device_id;
    if (deviceID) {
      const deviceResponse: any = await this.api.getRecord(
        this.$store,
        '/devices/' + deviceID
      );
      if (deviceResponse) {
        if (this.isNew) {
          const device = deviceResponse.data;
          rec.device.admin_address_id = device.admin_address_id;
          rec.device.owner_address_id = device.owner_address_id;
          rec.device.import_address_id = device.import_address_id;
          rec.device.user_address_id = device.user_address_id;
          rec.device.approval_id = device.approval_id;
          rec.device.supervisor_id = device.supervisor_id;
          rec.device.projectmanager_id = device.projectmanager_id;
          rec.device.construction_year = device.construction_year;
          rec.device.trafficlight = device.trafficlight;
          this.version += 1;

          rec.devicelines = device.devicelines;
          const deviceTestId = device.devicetest_id;
          const deviceTestLinesResponse: any = await this.api.getLines(
            this.$store,
            '/devicetests/' + deviceTestId
          );
          if (deviceTestLinesResponse) {
            const lines: LineValue[] = [];
            for (const line of deviceTestLinesResponse.data.data) {
              const l: LineValue = {
                id: 0,
                devicetestline_id: line.id,
                value: line.default,
                value_index: line.default_index,
                linedatatype: line.linedatatype,
                name: line.name,
                title_nl: line.title_nl,
                title_fr: line.title_fr,
                values_fr: line.values_fr,
                values_nl: line.values_nl
              };
              lines.push(l);
            }
            rec.reportlines = lines;
          }
        }
        const deviceTypeID = deviceResponse.data.devicetype_id;
        const deviceTypeResponse: any = await this.api.getRecord(
          this.$store,
          '/devicetypes/' + deviceTypeID
        );
        if (deviceTypeResponse) {
          const deviceType = deviceTypeResponse.data;
          rec.device.devicetype = {};
          rec.device.devicetype.road_tracks = deviceType.road_tracks;
          rec.device.devicetype.use_speed = deviceType.use_speed;
          rec.device.devicetype.curvometer = deviceType.curvometer;
          rec.device.devicetype.breath_analysis = deviceType.breath_analysis;
          if (this.isNew) {
            if (rec.device.devicetype.use_speed) {
              rec.speeds = deviceType.speeds;
            }
            if (rec.device.devicetype.breath_analysis) {
              rec.breaths = this.breaths;
              this.calculateMaxAllowedDev(rec);
            }
          }
        }
        // Let detail layout component know that something changed
        const ref: any = this.$refs.layout;
        ref.$refs.form.$emit('input');
      }
    }
  }

  public initPrivileges(rec) {
    const ref: any = this.$refs.layout;
    if (rec.conclusion && !this.isAdmin()) {
      ref.customManagePriv = false;
    }
  }

  public customSave() {
    const ref: any = this.$refs.layout;
    this.saveWithFiles(this.tableCfg.apiUrl);
    this.initPrivileges(ref.rec);
  }

  public mounted() {
    if (this.isNew) {
      const ref: any = this.$refs.layout;
      ref.rec.date = moment().format('YYYY-MM-DD');
      if (!this.isBreathAnalysis()) {
        ref.rec.due_date = moment()
          .subtract(1, 'days')
          .add(2, 'years')
          .format('YYYY-MM-DD');
      }
    }
  }
}
